import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { clevertapPush, ModificationCommonService } from '../../services/modification-common.service';
import { ConstantService } from '../../services/constant.service';
import { CommonModule, DatePipe } from '@angular/common';
import { UtilService } from '../../services/util.service';
import { Router } from '@angular/router';
import { EncryptionService } from '../../services/encryption.service';
import { AzureBlobService } from '../../services/azure-blob.service';
import { MaterialModule } from '../../material.module';
import { ProofSelectionService } from '../../services/proof-selection.service';
import { GetAzureBlobUrlReq, PushSegment2Req, PushSegmentReq, RaiseSegmentRequestInCRMReq, UploadManuallyReq, UploadSegmentManuallyReq } from '../../models/request.model';
import { CommonService } from '../../services/common.service';
import { PDFDocument } from 'pdf-lib';
import { UserSessionService } from '../../services/user-session.service';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';



@Component({
  selector: 'app-uploaded-proof',
  imports: [MaterialModule,CommonModule],
  templateUrl: './uploaded-proof.component.html',
  styleUrl: './uploaded-proof.component.less'
})
export class UploadedProofComponent {

    @ViewChild('password1') passwordInput1!: ElementRef;
    @ViewChild('password2') passwordInput2!: ElementRef;
    @ViewChild('fileUpload1') fileUpload1!: ElementRef;
    @ViewChild('fileUpload2') fileUpload2!: ElementRef;
    
    appSource!: string ;
    subSource!: string ;
    clientCode!: string ;
    ipAddress!: string ;
    inputFile: any | undefined;
    errorShow = false;
    ErrorMsg = '';
    uploadedFile1Base64: any | undefined = '';
    uploadedFile2Base64: any | undefined = '';
    upload1Data: any;
    upload2Data: any;
    btnText = 'Submit';
    salarySlab: any;
    //accept = '.jpg, .jpeg, .bmp, .pdf , .png';
    accept = '.pdf';
    isPdfFile! : boolean;
    format1 = '';
    format2 = '';
    btnLoader : boolean = false;
    fileTypeMap = new Map();
    fileName: string = '';
    proofType: string = '';
    setInterval:any;
    isEncryptedPdf: boolean = false;
    selectedFile!:File;
    proofCode!: number;

    constructor(
        private _bottomSheetRef: MatBottomSheetRef<UploadedProofComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
        private modificationCommonService: ModificationCommonService,
        private constantService: ConstantService,
        private datePipe: DatePipe,
        private utilService: UtilService,
        private router: Router,
        private encryptionService: EncryptionService,
        private azureBlobService: AzureBlobService,
        private proofSelectionService : ProofSelectionService,
        private commonService : CommonService,
        private userSessionService : UserSessionService,
        private _snackbar: MatSnackBar
    ) {
        this.appSource = userSessionService.getUserSessionData().appSource;
        this.clientCode = userSessionService.getUserSessionData().clientCode;

        this.fileTypeMap.set('application/pdf', 'PDF');
        this.fileTypeMap.set('image/jpeg', 'JPEG');
        this.fileTypeMap.set('image/png', 'PNG');
        this.fileTypeMap.set('image/bmp', 'BMP');
        this.fileTypeMap.set('image/jpg', 'JPG');

        this.upload1Data = data?.proof1;
        this.upload2Data = data?.proof2;
        this.format1 = data?.format1;
        this.format2 = data?.format2;
        this.proofType = data?.proofType;
        this.proofCode = data?.proofCode;

        this.uploadBankStatement(this.upload1Data);
        if (this.upload2Data != null || this.upload2Data != undefined) {
            this.uploadBankStatement(this.upload2Data, 'upload2');
        }
    }

    async ngOnInit() {
        this.salarySlab = JSON.parse(localStorage.getItem('salarySlab') || '');
        // this.getGetAzureBlobUrl();
    }

    getUploadSegmentManually() {
        const appSource =  'CLIENTWEB'; 
        const todayDt = this.datePipe.transform(new Date(), this.constantService.checksumDateFormate);
        const parameter = this.userSessionService.getUserSessionData().clientCode + appSource + this.userSessionService.getUserSessionData().ip + todayDt;
        const uploadSegmentManuallyReq : UploadSegmentManuallyReq = {
            head: {
                IPAddress:this.userSessionService.getUserSessionData().ip,
                AppSource: appSource,
                ChecksumValue: this.utilService.GenerateCheckSum(parameter, appSource)
            },
            body: {
                imgProof1: this.uploadedFile1Base64,
                clientCode: this.clientCode,
                password1:
                    this.passwordInput1?.nativeElement?.value == undefined
                        ? ''
                        : this.passwordInput1?.nativeElement?.value,
                password2:
                    this.passwordInput2?.nativeElement?.value == undefined
                        ? ''
                        : this.passwordInput2?.nativeElement?.value,
                Format1: this.fileTypeMap.get(this.format1),
                Format2: this.uploadedFile2Base64 == '' ? '' : this.fileTypeMap.get(this.format1),
                imgProof2:
                    this.uploadedFile2Base64 == undefined ||
                    this.uploadedFile2Base64 == '' ||
                    this.uploadedFile2Base64 == null
                        ? ''
                        : this.uploadedFile2Base64
            }
        };

        this.proofSelectionService.UploadSegmentManually(uploadSegmentManuallyReq).subscribe({next : (response) => {
            const data = {
                action: 'MOD_SEG_FILE_UPLOAD',
                parameter: 'Manual_Income_Proof_Uploaded',
                ProofType: this.proofType,
                fileName: this.fileName,
                isPassword: this.passwordInput1?.nativeElement?.value ? 'YES' : 'NO'
            };
            clevertapPush('Segment_Activation_MOD', data);
            const bodyStatus = response.body.Status;
              if (bodyStatus == 1) {
                    this.uploadedFile1Base64 = response.body.ImageByte1;
                    this.uploadedFile2Base64 = response.body.ImageByte2;
                    this.getPushSegment2();
                } else if (bodyStatus == 0) {
                    this.errorShow = true;
                    this.btnLoader = false;
                    const massage = 'Pdf1 Is Password Protected File. Provide Password In Password1 Field.';
                    this.ErrorMsg =
                        response.body.Message != massage
                            ? response.body.Message
                            : 'PDF is password protected, please provide password.';
                }
        },error : (err) => {
            this.btnLoader = false;
        },
    })
    }

     getUploadSegmentManually2() {
        const appSource =  this.userSessionService.getUserSessionData().appSource; 
        const todayDt = this.datePipe.transform(new Date(), this.constantService.checksumDateFormate);
        const parameter = this.userSessionService.getUserSessionData().clientCode + this.userSessionService.getUserSessionData().ip + appSource +  todayDt;
        // const uploadSegmentManuallyReq : UploadSegmentManuallyReq = {
        //     head: {
        //         IPAddress:this.userSessionService.getUserSessionData().ip,
        //         AppSource: appSource,
        //         ChecksumValue: this.utilService.GenerateCheckSum(parameter, appSource)
        //     },
        //     body: {
        //         imgProof1: this.uploadedFile1Base64,
        //         clientCode: this.clientCode,
        //         password1:
        //             this.passwordInput1?.nativeElement?.value == undefined
        //                 ? ''
        //                 : this.passwordInput1?.nativeElement?.value,
        //         password2:
        //             this.passwordInput2?.nativeElement?.value == undefined
        //                 ? ''
        //                 : this.passwordInput2?.nativeElement?.value,
        //         Format1: this.fileTypeMap.get(this.format1),
        //         Format2: this.uploadedFile2Base64 == '' ? '' : this.fileTypeMap.get(this.format1),
        //         imgProof2:
        //             this.uploadedFile2Base64 == undefined ||
        //             this.uploadedFile2Base64 == '' ||
        //             this.uploadedFile2Base64 == null
        //                 ? ''
        //                 : this.uploadedFile2Base64
        //     }
        // };

        const uploadSegmentManuallyReq : UploadManuallyReq ={
  ipAddress: this.userSessionService.getUserSessionData().ip,
  appSource: appSource,
  checkSumValue: this.utilService.GenerateCheckSum(parameter, appSource),
  clientCode: this.clientCode,
  password1: this.passwordInput1?.nativeElement?.value == undefined
                        ? ''
                        : this.passwordInput1?.nativeElement?.value,
  password2:  this.passwordInput2?.nativeElement?.value == undefined
                         ? ''
                         : this.passwordInput2?.nativeElement?.value,
  imageProof1: this.uploadedFile1Base64,
  imageProof2: this.uploadedFile2Base64 == undefined ||
                 this.uploadedFile2Base64 == '' ||
                 this.uploadedFile2Base64 == null
                     ? ''
                     : this.uploadedFile2Base64,
  format1: this.fileTypeMap.get(this.format1),
  format2: this.uploadedFile2Base64 == '' ? '' : this.fileTypeMap.get(this.format1)

        }
        this.commonService.uploadManually2(uploadSegmentManuallyReq).subscribe({next : (response) => {
            const data = {
                action: 'MOD_SEG_FILE_UPLOAD',
                parameter: 'Manual_Income_Proof_Uploaded',
                ProofType: this.proofType,
                fileName: this.fileName,
                isPassword: this.passwordInput1?.nativeElement?.value ? 'YES' : 'NO'
            };
            clevertapPush('Segment_Activation_MOD', data);
            const bodyStatus = response.status;
              if (bodyStatus == 1) {
                    this.uploadedFile1Base64 = response.data.imageBytes1;
                    this.uploadedFile2Base64 = response.data.imageBytes2;
                    this.getPushSegment2();
                } else if (bodyStatus == 0) {
                    this.errorShow = true;
                    this.btnLoader = false;
                    const massage = 'Pdf1 Is Password Protected File. Provide Password In Password1 Field.';
                    this.ErrorMsg =
                        response.msg != massage
                            ? response.msg
                            : 'PDF is password protected, please provide password.';
                }
        },error : (err) => {
            this.btnLoader = false;
            const msg=err.error.message;
            if (err.error.httpCode == 422) {
                this.errorShow = true;
                 this.btnLoader = false;
                    const massage = 'Pdf1 Is Password Protected File. Provide Password In Password1 Field.';
                    this.ErrorMsg =
                        msg != massage
                            ? msg
                            : 'PDF is password protected, please provide password.';
            }
        },
    })
    }
    
    uploadBankStatement(event: any, type: string = 'upload1') {
        this.errorShow = false;
        this.ErrorMsg = '';
        try {
            this.selectedFile = <File>event.target.files[0];
            
            const format = this.selectedFile.type;
            if (this.fileTypeMap.has(format)) {
                this.fileName = this.selectedFile.name;
                if (this.selectedFile.type.includes('/pdf')) {
                    this.isPdfFile = true;
                } else {
                    this.isEncryptedPdf = false;
                    this.isPdfFile = false;
                }
                const fileSize = this.selectedFile.size / 1024;
                if (fileSize > 10240) {
                    this.errorShow = true;
                    this.ErrorMsg = 'File size should not be more than 10 MB.';
                    return;
                }
                if (this.selectedFile) {
                    var reader = new FileReader();
                    reader.readAsDataURL(this.selectedFile);
                    reader.onload = async (event :  any) => {
                        var arrayBuffer = event.target.result;
                        try {
                            if (this.isPdfFile) {
                                const pdfDoc = await PDFDocument.load(arrayBuffer, { ignoreEncryption: true });
                                if (pdfDoc.isEncrypted) {
                                    this.isEncryptedPdf = true
                                    this.errorShow = true;
                                    this.ErrorMsg = 'PDF is password protected, please provide password.';
                                } else if (!pdfDoc.isEncrypted) {
                                    this.isEncryptedPdf = false;
                                    this.errorShow = false;
                                    this.ErrorMsg = '';
                                }
                            }
                            var selectedFile : any = selectedFile;
                            let base64 = '' + event.target.result;
                            let fileInByte = base64.split(',')[1];
                            if (type == 'upload1') {
                                this.uploadedFile1Base64 = fileInByte;
                                this.format1 = format;
                            } else if (type == 'upload2') {
                                this.uploadedFile2Base64 = fileInByte;
                                this.format2 = format;
                            }
                            // const arrayBuffer1 = await selectedFile.arrayBuffer();
                            //  const loadingTask = pdfjsLib.getDocument({
                            //      data: arrayBuffer1,
                            //      password: 'PREM856025453'
                            //  });
                            //   const pdf = await loadingTask.promise;
                            //   const pdfBytes = await pdf.save();
                            //   const newPdfBytes = await pdfDoc.save();
                            //   console.log(newPdfBytes);
                            //  newPdfBytes;
                        } catch (error) {
                            this.errorShow = true;
                            this.ErrorMsg = 'PDF is password protected, please provide password.';
                            console.log(error);
                            console.error('Error loading PDF without password:', error);
                        }
                    };
                }
            } else {
                this.errorShow = true;
                this.ErrorMsg = 'Please upload valid file type.';
            }
        } catch (e) {
            console.log(e);
        }
    }

    getPushSegment() {
        const appSource = 'CLIENTWEB'
        // const todayDt = this.datePipe.transform(new Date(), this.constantService.checksumDateFormate);
        const parameter = this.userSessionService.getUserSessionData().clientCode + appSource + this.userSessionService.getUserSessionData().ip + this.utilService.checkSumDate;
        const dematAccountNo = this.encryptionService.decryptUsingAES256AndRFC2898(
            localStorage.getItem('dematAccountNo') || ''
        );

        const pushSegmentReq : PushSegmentReq = {
            head: {
                ipAddress: this.userSessionService.getUserSessionData().ip,
                appSource: appSource,
                checkSumValue:  this.utilService.GenerateCheckSum(parameter,appSource)
            },
            body: {
                typeOfModification: '2',
                clientCode:  this.userSessionService.getUserSessionData().clientCode,
                dpAccountNo: dematAccountNo,
                incomeSlab: this.salarySlab?.values,
                proofCode1: this.proofCode.toString(),
                proofCode2: this.proofCode.toString(),
                img_Proof1: this.uploadedFile1Base64,
                img_Proof2:
                    this.uploadedFile2Base64 == undefined ||
                    this.uploadedFile2Base64 == '' ||
                    this.uploadedFile2Base64 == null
                        ? ''
                        : this.uploadedFile2Base64,
                imgType1: this.fileTypeMap.get(this.format1),
                imgType2: this.uploadedFile2Base64 == '' ? '' : this.fileTypeMap.get(this.format1),
            }
        };

        this.commonService.
            PushSegment(pushSegmentReq).subscribe({next:(response : any) =>{
                if (response.body.Status == 1) {
                    clevertapPush('Segment_Activation_MOD', {
                        parameter1: 'MOD_SEG_MANUAL_SUBMIT',
                        parameter2: 'Segment_Activation_Request_Submitted'
                    });
                    this.router.navigate(['/derivative/successfull-request'], { queryParams: { manually: true } });
                    this._bottomSheetRef.dismiss();
                }
                else{
                    this.btnLoader = false;
                }
            },error:(err) =>{
                this.btnLoader = false;
            },
        })
          
    }

    getPushSegment2() {
        const dematAccountNo = this.encryptionService.decryptUsingAES256AndRFC2898(
            localStorage.getItem('dematAccountNo') || ''
        );

        //  clientCode + ipAddress +  appSource (UPPER CASE) + incomeSlab
        const parameter = this.userSessionService.getUserSessionData().clientCode +this.userSessionService.getUserSessionData().ip +this.userSessionService.getUserSessionData().appSource.toUpperCase() + this.salarySlab?.values + this.utilService.checkSumDate;
        const pushSegment2Req : PushSegment2Req = {
            ipAddress: this.userSessionService.getUserSessionData().ip,
            appSource: this.userSessionService.getUserSessionData().appSource,
            checkSumValue:this.utilService.GenerateCheckSum(parameter),
            clientCode: this.userSessionService.getUserSessionData().clientCode,
            typeOfModification:'2',
            incomeSlab: this.salarySlab?.values,
            dpAccountNo: dematAccountNo,
            proofCode1:  this.proofCode.toString(),
            imageProof1: this.uploadedFile1Base64,
            imageType1:  this.fileTypeMap.get(this.format1),
            proofCode2: this.proofCode.toString(),
            imageProof2: 
                    this.uploadedFile2Base64 == undefined ||
                    this.uploadedFile2Base64 == '' ||
                    this.uploadedFile2Base64 == null
                        ? ''
                        : this.uploadedFile2Base64,
            imageType2: this.uploadedFile2Base64 == '' ? '' : this.fileTypeMap.get(this.format1),
        };
    
          this.commonService.PushSegment2(pushSegment2Req).subscribe({next:(responce)=>{
           const data = {
              income_range: this.salarySlab?.values
          };
          clevertapPush('Segment_Activation_MOD', {
                        parameter1: 'MOD_SEG_MANUAL_SUBMIT',
                        parameter2: 'Segment_Activation_Request_Submitted'
            });
            this.router.navigate(['/derivative/successfull-request'], { queryParams: { manually: true } });
            this._bottomSheetRef.dismiss();
          },error:(err)=>{
            const message = err.error.message
            if (err.error.status == 2 || err.error.httpCode == 422) {
            this._snackbar.openFromComponent(SnackbarComponent, {
            data: [message],
            duration: this.constantService.snackBarDuration,
            panelClass: ['failed-popup']
        });
            this.router.navigateByUrl('/derivative/fail-page');
            this._bottomSheetRef.dismiss();
        }
          
          }})
    }



    onFocus() {
        this.errorShow = false;
        this.ErrorMsg = '';
    }
    submitBtn() {
        this.btnLoader = true;
        this.getUploadSegmentManually2();
       // this.getGetAzureBlobUrl();
    }

    ngOnDestroy() {
        this._bottomSheetRef.disableClose;
    }

    getGetAzureBlobUrl() {
        const todayDt = this.datePipe.transform(new Date(), this.constantService.checksumDateFormate);
        const parameter = this.clientCode + 'Segment' + '1' + todayDt;
        const checkSumValue = this.utilService.GenerateCheckSum(this.appSource, parameter);
        const basicAuth = localStorage.getItem('Authorization');
        const getAzureBlobUrlReq : GetAzureBlobUrlReq = {
            head: {
                ipAddress: this.ipAddress,
                appSource: this.appSource,
                checkSumValue: checkSumValue
            },
            body: {
                clientCode: this.clientCode,
                proofType: 'Segment',
                index: '1',
                extType: this.format1.split('/')[1],
                proof: ''
            }
        };

        this.proofSelectionService.GetAzureBlobUrl(getAzureBlobUrlReq).subscribe({next : async (response : any) => {
            this.btnLoader = false;
                ('https://diyfuncstorage.blob.core.windows.net/modificationfiles/52361347/52361347_Segment_1_20240626.pdf');
                const url = response.data.body.url;
                const urlSplit = url.split('/' + this.clientCode + '/');
                const file_Name = urlSplit[urlSplit.length - 1];
                // const pdfFile = new Blob([this.uploadedFile1Base64], { type: this.format1 });
                const sasUrl = urlSplit[0] + `/${this.clientCode}` + '?' + response.data.body.token;
                try {
                    // if( this.passwordInput1?.nativeElement?.value){
                    //     // this.tempBuffer1 = await this.azureBlobService.removePassword(this.tempBuffer,this.passwordInput1?.nativeElement?.value, sasUrl);
                    // }
                    // else{
                    // console.log('File uploaded successfully', response);
                    // }
                    const response = await this.azureBlobService.uploadFile(this.selectedFile, sasUrl, file_Name);
                } catch (error) {
                    console.error('Error uploading file', error);
                }
                this.getRaiseSegmentRequest(url);
        },error: (err)=> {},})
    }

    getRaiseSegmentRequest(url: string) {
        const dematAccountNo = this.encryptionService.decryptUsingAES256AndRFC2898(
            localStorage.getItem('dematAccountNo') || ''
        );
        //reqobj.body.clientCode + reqobj.body.TypeOfModification + reqobj.head.AppSource + reqobj.body.ImgType1 + reqobj.body.DPAccountNo + todayDt;
        const todayDt = this.datePipe.transform(new Date(), this.constantService.checksumDateFormate);
        const parameter =
            this.clientCode + '2' + this.appSource + this.format1.split('/')[1] + dematAccountNo + todayDt;
        const checkSumValue = this.utilService.GenerateCheckSum(this.appSource, parameter);
        const raiseSegmentRequestInCRMReq:RaiseSegmentRequestInCRMReq = {
            head: {
                ipAddress: this.ipAddress,
                appSource: this.appSource,
                checkSumValue: checkSumValue
            },
            body: {
                typeOfModification: 2,
                clientCode: this.clientCode,
                dpAccountNo: dematAccountNo,
                incomeSlab: this.salarySlab?.values,
                proofCode: 22,
                img_Proof: url,
                imgType: this.format1.split('/')[1],
                isPdfPassword: this.passwordInput1?.nativeElement?.value ?? ''
            }
        };
        const basicAuth = localStorage.getItem('Authorization');
        this.proofSelectionService.RaiseSegmentRequestInCRM(raiseSegmentRequestInCRMReq).subscribe({next: (response) =>{
            if (response.data.status == '1') {
                this.router.navigateByUrl('/derivative/successfull-request');
                this._bottomSheetRef.dismiss();
            }
        },error :(err:any)=>{

        }, })
    }
}
